<div class="fiche-section">
  <div class="fiche-section-title">Soumettre une demande</div>
  <div class="fiche-section-box">

    @if (isLoadingPeriods()) {
      <div class="flex items-center gap-2 text-sm text-stone-500 py-2">
        <svg class="w-4 h-4 animate-spin text-primary-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
        </svg>
        Chargement des périodes…
      </div>
    } @else {

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <!-- Type de demande -->
        <div class="fiche-field">
          <span class="fiche-label-fixed">Type de demande</span>
          <select
            [(ngModel)]="form.demande_type"
            name="demande_type"
            class="fiche-input-mock w-full bg-white border border-stone-200 rounded px-3 py-2 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
          >
            @for (type of currentDemandeTypes; track type.value) {
              <option [value]="type.value">{{ type.label }}</option>
            }
          </select>
        </div>

        <!-- Période de licence -->
        <div class="fiche-field">
          <span class="fiche-label-fixed">Période de licence</span>
          @if (licencePeriods().length === 0) {
            <div class="fiche-input-mock text-stone-400 italic">Aucune période ouverte</div>
          } @else {
            <select
              [(ngModel)]="form.licenceperiod_id"
              name="licenceperiod_id"
              class="fiche-input-mock w-full bg-white border border-stone-200 rounded px-3 py-2 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
            >
              @for (period of licencePeriods(); track period.licenceperiod_id) {
                <option [value]="period.licenceperiod_id">{{ period.licenceperiod_name }}</option>
              }
            </select>
          }
        </div>

        <!-- Motif (optionnel) -->
        <div class="fiche-field md:col-span-2">
          <span class="fiche-label-fixed">Motif <span class="text-stone-400 font-normal">(optionnel)</span></span>
          <textarea
            [(ngModel)]="form.motif"
            name="motif"
            rows="3"
            placeholder="Précisez un motif si nécessaire…"
            class="fiche-input-mock w-full bg-white border border-stone-200 rounded px-3 py-2 text-sm text-stone-800 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
          ></textarea>
        </div>

      </div>

      <!-- Submit Button -->
      <div class="flex justify-end mt-4">
        @if (permService.can('licence', 'demandes', 'submit')) {
          <button
            type="button"
            (click)="submit()"
            [disabled]="isSubmitting() || licencePeriods().length === 0"
            class="inline-flex items-center gap-2 text-sm font-semibold px-5 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            @if (isSubmitting()) {
              <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              Envoi en cours…
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
              </svg>
              Soumettre la demande
            }
          </button>
        }
      </div>

    }
  </div>
</div>
